// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '@babel/polyfill'
import { store } from './store/store'

Vue.config.productionTip = false

/* eslint-disable no-new */
let app = new Vue({
  store,
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

global.vm = app



// WEBPACK FOOTER //
// ./src/main.js